export const DOUBLE_CLICK_TIME = 300;
export const ENTER_KEY = 'Enter';
export const ESCAPE_KEY = 'Escape';
export const ARROW_DOWN_KEY = 'ArrowDown';
export const ARROW_UP_KEY = 'ArrowUp';
export const STRING_WITH_ZERO = '0';
export const RADIX = 10;
export const KILOBYTE = 1024;
export const GIGABYTE = Math.pow(KILOBYTE, 3);
export const MILLISECOND = 1000;
export const HOUR = 60 * 60 * MILLISECOND;

export const EMAIL_REGEX = /([\w.-]+@([\w-]+)\.+\w{2,})/;

export const UNASSIGNED = '00000000-0000-0000-0000-000000000000';

export const DEFAULT_FRACTIONS_NUMBER = 3;

export const EXTERNAL_PROVIDER_CALLBACK_URL = '/callback';

export const SESSION_TABLE_KEY = 'TABLES';
export const SUPPORT_LOGIN_KEY = 'IS_SUPPORT_LOGIN';
export const LICENSE_PLATE_REGEX = /[^\p{L}\p{N}]+/gu;
export const LICENSE_PLATE_MAX_LENGTH = 15;

export const APP_CLASSNAME = 'app';
